// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"organism3-m__wrapper__IVqtZ"};